import * as React from 'react';
import { SVGProps } from 'react';

const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m9.647 14.308-3.765-3.692L4 12.462 9.647 18 20 7.846 18.118 6l-8.471 8.308z" />
  </svg>
);

export default SvgCheck;
